import { useMemo } from "react";
import { qrContent, qrMatrix, qrPath } from "./qr";

/** QR-code als SVG (scherp op elk formaat, ook printbaar). */
export function QrCode({ code, size = 160, label }: { code: string; size?: number; label: string }) {
  const { d, n } = useMemo(() => {
    const m = qrMatrix(qrContent(code));
    return { d: qrPath(m), n: m.size + 8 };
  }, [code]);
  return (
    <svg className="qrcode" viewBox={`0 0 ${n} ${n}`} width={size} height={size} role="img" aria-label={label}>
      <rect width={n} height={n} fill="#fff" />
      <path d={d} fill="#000" shapeRendering="crispEdges" />
    </svg>
  );
}
